import { render, staticRenderFns } from "./ToolbarButton.vue?vue&type=template&id=f2b36300&scoped=true&"
import script from "./ToolbarButton.vue?vue&type=script&lang=js&"
export * from "./ToolbarButton.vue?vue&type=script&lang=js&"
import style0 from "./ToolbarButton.vue?vue&type=style&index=0&id=f2b36300&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b36300",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2b36300')) {
      api.createRecord('f2b36300', component.options)
    } else {
      api.reload('f2b36300', component.options)
    }
    module.hot.accept("./ToolbarButton.vue?vue&type=template&id=f2b36300&scoped=true&", function () {
      api.rerender('f2b36300', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/ToolbarButton.vue"
export default component.exports